'use strict';

import { Dropdown } from './dropdown.js';

export class DropdownMyadsemails extends Dropdown {
	constructor(component_key) {
		super(component_key);
	}
	add_events() {
		jQuery(`.js-${this.id}_option`).on('click', this.option_click_handler.bind(this));
		jQuery(`.js-${this.id}`).on('blur', this.close_all.bind(this));
	}
	option_click_handler(event) {
		const $element = jQuery(event.currentTarget);
		if (!$element.is(':first-child')) {
			yalwa.basics.set_get({e: $element.data('value'), p: 1}, true, true);
		}
		yalwa.basics.bem_modifier(this.$list, 'active', 'toggle');
		yalwa.basics.bem_modifier(this.$options, 'active', 'toggle');
	}
}
